module.exports = __webpack_public_path__ + "static/media/sv.eeb6c1d3.svg";